import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Propane",
  "description": "",
  "published": "2007-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/propane/swizec/325"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.liveleak.com/view?i=08b0f84d82&c=1"
      }}>{`Shooting propane tanks`}</a>{` looks like fun, but guys, holding the camera still might actually be even more fun.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      